import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { Badge } from '../../../../molecules/badge'
import { cn } from '../../../../../_shared/lib'

// 質問例のデータ定義
export const GUIDE_QUESTIONS: string[] = [
  'トヨタとホンダを比較して',
  'ソニーとエイベックスを比較して',
  '任天堂、バンナムとコナミを比較して',
  'ビール業界大手について教えて',
  'エンタメ業界大手について教えて',
  'ゲーム業界大手について教えて',
  'ソフトバンクの財務状況を要約して',
  'トヨタの関係会社一覧はどこに書いてある？',
  'セブン&アイの社外取締役は？',
]

/**
 * 指定された数の質問例をランダムに選択して返す
 * @param count 選択する質問数（デフォルト: 4）
 * @returns ランダムに選択された質問例の配列
 */
export const getRandomGuideQuestions = (count: number = 4): string[] => {
  const shuffled = [...GUIDE_QUESTIONS].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, Math.min(count, GUIDE_QUESTIONS.length))
}

interface GuideQuestionsProps {
  questions: string[]
  onQuestionClick: (question: string) => void
  show: boolean
}

export const GuideQuestions: React.FC<GuideQuestionsProps> = ({ questions, onQuestionClick, show }) => {
  if (!show || questions.length === 0) {
    return null
  }

  return (
    <div className="relative pb-4 z-[1000]">
      <div className="flex flex-col gap-2">
        <AnimatePresence>
          {show &&
            questions.map((question, index) => (
              <motion.div
                key={question}
                initial={{
                  opacity: 0,
                  y: 20,
                  scale: 0.9,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  y: -10,
                  scale: 0.95,
                }}
                transition={{
                  duration: 0.3,
                  delay: index * 0.1, // 各質問を100ms遅延
                  ease: [0.25, 0.46, 0.45, 0.94], // カスタムイージング
                }}
                whileHover={{
                  scale: 1.02,
                  transition: { duration: 0.2 },
                }}
                whileTap={{
                  scale: 0.98,
                  transition: { duration: 0.1 },
                }}
              >
                <Badge
                  onClick={() => onQuestionClick(question)}
                  className={cn(
                    'cursor-pointer bg-white border border-gray-300 shadow-sm',
                    'hover:bg-blue-50 hover:border-blue-500 hover:shadow-md',
                    'active:shadow-sm',
                    'text-sm font-medium text-gray-900',
                    'px-4 py-2 h-auto max-w-full',
                    'transition-all duration-200',
                  )}
                  variant="outline"
                >
                  {question}
                </Badge>
              </motion.div>
            ))}
        </AnimatePresence>
      </div>
    </div>
  )
}
